import React from 'react'
import './Home.module.css'
import 'bootstrap/dist/css/bootstrap.min.css'
const AboutRotary = () => {
    return (
        <>

            <section className="section-sp1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className='text-center title-head'>About Rotary</h1>
                            <p style={{ textAlign: "justify", lineHeight: 2 }}>
                                Rotary is a service association of business and professional leaders, united worldwide, who conduct humanitarian projects, encourage high ethical standards in all vocations and works towards world understanding and peace. The first such club was formed at CHICAGO IN 1905, followed by a club at San Francisco in 1908.The first club in Europe was formed in Ireland in 1911. In 1922, the name was changed to Rotary International.
                            </p>
                            <p style={{ textAlign: "justify", lineHeight: 2 }}>
                                Rotary Club kota was founded in 1989 in the presence of I's first member Rtn. Ravi Khosla. After the insception Roatary Club kota take responsibility to continue the social welfare works in the guidance of Rotary International and Members Team.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default AboutRotary